import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { ListItem } from 'src/components/ListItem';
import { TextField } from 'src/components/TextField';
import { Group } from 'src/models/group/_types';
import { fetchAllGroups } from 'src/models/group/group';

interface GroupFilterConfig {
  field: string;
  label: string;
  value: any;
  setValue: (newVal: any, close?: boolean) => void;
  valueOnly?: boolean;
  includeNoGroupOption?: boolean;
}
export const GroupFilter: React.FC<GroupFilterConfig> = ({
  label,
  value,
  setValue,
  valueOnly,
  includeNoGroupOption,
}) => {
  const setGroupValue = (value: Group) => {
    setValue(value?.id ?? null, true);
  };
  const { data: groups, isLoading } = useQuery({
    queryKey: ['groups'],
    queryFn: () => {
      return fetchAllGroups();
    },
    staleTime: 60000,
  });

  const options = [
    { name: 'Any', id: null },
    ...(includeNoGroupOption ? [{ name: 'No Group', id: -1 }] : []),
    ...(groups || []),
  ];

  const selectedGroup = options?.find((group) => group.id == value) || null;

  if (valueOnly) {
    return <>{selectedGroup?.name}</>;
  }

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(group: Group) => group.name || 'Loading'}
      value={selectedGroup}
      onChange={(_, newValue: Group) => setGroupValue(newValue)}
      loading={isLoading}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Any" />
      )}
      renderOption={(props, group) => {
        return (
          <ListItem
            {...(props as any)}
            clickable
            primary={group.name}
            key={group.name + group.id}
          />
        );
      }}
    />
  );
};
